/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState} from 'react'
import { Link, useParams } from 'react-router-dom'
import { Toaster} from 'react-hot-toast'
import AppContainer from "../../Components/Structure/AppContainer";
import Loader from '../../Components/Common/Loader';
import useStateCallback from '../../util/customHooks/useStateCallback';
import TableHeader from '../../Components/Common/TableHeader';
import AddGroup from '../../Components/Schools/SchoolProfile/AddGroup';
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import SchoolContext from '../../Context/SchoolContext';
import StudentsList from '../../Components/Schools/SchoolProfile/StudentsList';
import Pagination from '../../Components/Common/Pagination';
import SearchForm from '../../Components/Common/SearchForm';
import SummaryCount from '../../Components/Schools/SchoolProfile/SummaryCount';
import StationList from '../../Components/Schools/SchoolProfile/StationList';
import SchoolInformation from '../../Components/Schools/SchoolProfile/SchoolInformation';
import SchoolStudentGroups from '../../Components/Schools/SchoolProfile/SchoolStudentGroups';
import ajaxStudent from '../../util/remote/ajaxStudent';
import ajaxSchool from '../../util/remote/ajaxSchool';
import ajaxCard from '../../util/remote/ajaxCard';
import { OverlayTrigger, Tooltip } from "react-bootstrap";


const SchoolProfilePage = props => {

  const {setSchoolId, getGroups, studentCount, stationCount, schoolStations,
    schoolGroups, stationFirst, stationMeta, stationPage, setStationPage} = useContext(SchoolContext);
  const [schoolStudents, setSchoolStudents] = useState([]);
  const [schoolProfile, setSchoolProfile] = useState(false);
  const [assignedPerClass, setAssignedPerClass] = useState([]);
  const [schoolRank, setSchoolRank] = useState([]);
  
  const [studentsPage,setStudentsPage] = useState(1)
  const [studentsMeta,setStudentsMeta] = useState([])
  const [studentsFirst, setStudentsFirst] = useState("");
  const [studentsQuery, setStudentsQuery] = useState("");
  const [modal, setModal] = useStateCallback(false);
  const {id} = useParams();
  const [loading3,setLoading3] = useState(false)
  const [loading4,setLoading4] = useState(false)
  const [loading1,setLoading1] = useState(false)
  const [loading5,setLoading5] = useState(false)
  const [loading6,setLoading6] = useState(false)

  useEffect(() => {
      if (id) {
        getSchoolProfile();
        getAssignedPerClass();
        getSchoolRankings();
      }
    }, [id]);

  useEffect(() => {
    if(id){
      if (studentsQuery) {
        searchSchoolStudents();
      } else {
        getSchoolStudents(studentsPage, id);
      }
    }  
  }, [studentsPage, id]);

  const setStudents = (e) => {
    e.preventDefault();
    setStudentsQuery("");
    setStudentsPage(1);
    getSchoolStudents(1);
  };

  const getSchoolStudents = async (currentPage) => {
      setLoading3(true);
      const server_response = await ajaxStudent.fetchStudentList(currentPage, id);
      setLoading3(false);
      if (server_response.status === "OK") {
        setStudentsFirst(server_response.details.meta.offset);
        setStudentsMeta(server_response.details.meta.totalPages);
        setSchoolStudents(server_response.details.list || []);
      } else {
        setSchoolStudents([]);
      }
    };

    const searchSchoolStudents = async (e) => {
      if (e) {
        e.preventDefault();
      }
      setLoading4(true);
      const server_response = await ajaxStudent.searchSchoolStudents(studentsPage, id, studentsQuery);
      setLoading4(false);
      if (server_response.status === "OK") {
        setStudentsFirst(server_response.details.meta.offset);
        setStudentsMeta(server_response.details.meta.totalPages);
        setSchoolStudents(server_response.details.list || []);
      } else {
        setSchoolStudents([]);
      }
    };

  const getSchoolProfile = async () => {
      if (!id) return;
      setLoading1(true)
      const server_response = await ajaxSchool.fetchSchoolProfile(id);
      setLoading1(false)
      if (server_response.status === "OK") {
        setSchoolProfile(server_response.details);
      } else {
        setSchoolProfile("404");
      }
    };

  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= studentsMeta) {
      setStudentsPage(newPage);
    }
  };

  const handlePagination1 = (newPage) => {
    if (newPage > 0 && newPage <= stationMeta.length) {
      setStationPage(newPage);
    }
  };

  const getAssignedPerClass = async () => {
    setLoading5(true);
      const server_response = await ajaxCard.totalCardsAndWristbandsPerClass(id);
      setLoading5(false);
      if (server_response.status === "OK") {
        setAssignedPerClass(server_response.details);
      } else {
        setAssignedPerClass([]);
      }
  };

  const getSchoolRankings = async () => {
    setLoading6(true);
      const server_response = await ajaxSchool.fetchSchoolRankings(id);
      setLoading6(false);
      if (server_response.status === "OK") {
        setSchoolRank(server_response.details);
      } else {
        setSchoolRank([]);
      }
  };

  const handleCardsReset = (e) => {
    e.preventDefault();
    getAssignedPerClass();
    
  };

  

  

    useEffect(() => {
      setSchoolId(id);
    }, [id, setSchoolId]);

  const handleModal3=()=>{
      setModal(false, ()=>setModal(<AddGroup schoolID={id} g={getGroups} isOpen={true}/>))
  }

  return (
    <AppContainer title={"School Profile"} >
      <Toaster position="top-center" reverseOrder={false}/>
      {modal}

      <section class="section profile">
        <div class="row">
          <div class="col-xl-5">
            <SchoolInformation schoolId={id} schoolProfile={schoolProfile} getSchoolProfile={getSchoolProfile} loading={loading1}/>

            <div className="col-lg-12">
                      <div className="card custom-card mt-3" style={{paddingBottom:"10px"}}>
                        <div className="card-body map-card">
                        <TableHeader
                            title="Assigned Cards / Wristbands Per Class"
                            subtitle="Total number of assigned cards and wristbands for each class in the school"
                            viewButton={
                              <Link onClick={handleCardsReset} className="" style={{float:"right"}}><i class="fas fa-redo-alt ml-3"></i></Link>
                                 
                          } 
                        />
                        
    {loading5? (
  <Loader/>
) : (
  <table className="table mb-0 mw-100 color-span">
    <thead>
                <tr>
                <th className="w-50">Class</th>
                <th></th>

                <th className="py-2 px-0" scope="col">Cards</th>
                <th className="py-2 px-0"scope="col"> Wristbands</th>
                </tr>
                </thead>
    <tbody>
      {Object.keys(assignedPerClass).length > 0 ? (
        Object.keys(assignedPerClass).map((classId, index) => {
          const group = assignedPerClass[classId];
          return (
            <tr key={index}>
              <td className="py-2 px-0">
                <span className="w-50">{group.group_name}</span>
              </td>
              <td>:</td>
              <td className="py-2 px-0">
                <span className="">
                  {group.assigned["CARD"] !== undefined ? group.assigned["CARD"] : 0}
                </span>
              </td>
              <td className="py-2 px-0">
                <span className="">
                  {group.assigned["WRISTBAND"] !== undefined ? group.assigned["WRISTBAND"] : 0}
                </span>
              </td>
            </tr>
          );
        })
      ) : (
        <tr>
          <td colSpan="4" style={{ textAlign: "center" }}>
            No cards or wristbands assigned to any student.
          </td>
        </tr>
      )}
    </tbody>
  </table>
)}

                        </div>
                      </div>
                    </div>
          </div>

          <div className='col-xl-7'>
            <div className="row">
              <SummaryCount studentCount={studentCount} stationCount={stationCount}/>

              <div class="col-lg-12">
                <div class="card">
                  <div class="card-body pt-3">
                  <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                  <Row>
                    <Col sm={12}>
                      <Nav variant="pills" className="flex-row mb-1">
                        <Nav.Item>
                          <Nav.Link size="sm" eventKey="first">
                            Student List{" "}
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link size="sm" eventKey="second">
                            Student Groups{" "}
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link size="sm" eventKey="third">
                            Calling Stations{" "}
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link size="sm" eventKey="fourth">
                            Student Leaderboard{" "}
                          </Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </Col>

                    <Col sm={12}>
                      <Tab.Content>
                        <Tab.Pane eventKey="first">
                          <SearchForm searchTerm={studentsQuery} setSearchTerm={setStudentsQuery} searchItems={searchSchoolStudents} setItems={setStudents}
                          setPage={setStudentsPage} placeholder="Search for student name..."/>

                          <div className="table-responsive">
                            {loading4 || loading3 ? (
                              <Loader /> 
                            ) : (
                              <StudentsList schoolStudents={schoolStudents} studentsFirst={studentsFirst}/>
                            )}
                          </div>

                          <Pagination currentPage={studentsPage} totalPages={studentsMeta} onPageChange={handlePagination}/>
                        </Tab.Pane>

                        <Tab.Pane eventKey="second">
                          <TableHeader
                            subtitle="List of all the student groups" 
                            viewButton={
                                <Link onClick={handleModal3} className="btn btn-info" style={{float:"right"}}>Add Student Group</Link>    
                            }        
                          /> 
                          <SchoolStudentGroups groupList={schoolGroups}/>

                        </Tab.Pane>

                        <Tab.Pane eventKey="third">
                      
                          <div className="border-top mt-1"></div>
                          <div className="table-responsive">
                            {loading3 ? (
                              <Loader />
                            ) : (
                              <StationList schoolStations={schoolStations} stationFirst={stationFirst}/>
                            )}
                          </div>

                          <Pagination currentPage={stationPage} totalPages={stationMeta.length} onPageChange={handlePagination1}/>

                        </Tab.Pane>
                        <Tab.Pane eventKey="fourth">
                            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                  <Row>
                    <Col sm={12}>
                      <Nav variant="underline" className="flex-row mb-1">
                        <Nav.Item>
                          <Nav.Link size="sm" eventKey="first">
                            <OverlayTrigger placement="top" overlay={
                              <Tooltip id="refresh-tooltip">Buzz Calls</Tooltip>}>
                                <i class="fas fa-phone-volume"></i></OverlayTrigger>
                            {" "}
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link size="sm" eventKey="second">
                            <OverlayTrigger placement="top" overlay={
                              <Tooltip id="refresh-tooltip">Video Calls</Tooltip>}>
                                <i class="fas fa-video"></i></OverlayTrigger>
                            {" "}
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link size="sm" eventKey="third">
                            <OverlayTrigger placement="top" overlay={
                              <Tooltip id="refresh-tooltip">Direct Calls</Tooltip>}>
                                <i class="fas fa-phone"></i></OverlayTrigger>
                            {" "}
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link size="sm" eventKey="fourth">
                            <OverlayTrigger placement="top" overlay={
                              <Tooltip id="refresh-tooltip">Chats</Tooltip>}>
                                <i class="fas fa-message"></i></OverlayTrigger>
                            {" "}
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link size="sm" eventKey="fifth">
                            <OverlayTrigger placement="top" overlay={
                              <Tooltip id="refresh-tooltip">Voice Notes</Tooltip>}>
                                <i class="fas fa-microphone"></i></OverlayTrigger>
                            {" "}
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link size="sm" eventKey="sixth">
                            <OverlayTrigger placement="top" overlay={
                              <Tooltip id="refresh-tooltip">Direct Messages</Tooltip>}>
                                <i class="fas fa-comment-sms"></i></OverlayTrigger>
                            {" "}
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link size="sm" eventKey="seventh">
                            <OverlayTrigger placement="top" overlay={
                              <Tooltip id="refresh-tooltip">Booth Sessions</Tooltip>}>
                                <i class="fas fa-person-booth"></i></OverlayTrigger>
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link size="sm" eventKey="eighth">
                            <OverlayTrigger placement="top" overlay={
                              <Tooltip id="refresh-tooltip">Canteen Purchases</Tooltip>}>
                                <i class="fas fa-credit-card"></i></OverlayTrigger>
                          </Nav.Link>
                        </Nav.Item>

                      </Nav>
                    </Col>

                    <Col sm={12}>
                      <Tab.Content>
                        <Tab.Pane eventKey="first">
                          <div className="table-responsive">
                            {loading6 ? (
                              <Loader /> 
                            ) : (
                              <table className="table table-hover text-nowrap mg-b-0">
                                      <thead>
                                        <tr>
                                        <th scope="col" >Pos</th>
                                        <th>Names</th>
                                        <th>Total</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {schoolRank?.voice_calls?.length > 0 ? (
                                          schoolRank?.voice_calls?.map((item, index) => (
                                            <tr key={index}>
                                               <td>{item.state === "same"? <i class="fas fa-minus"></i>:item.state ==="down"? <i class="fas fa-caret-down" style={{color:"#dc3545"}}></i>: <i class="fas fa-caret-up"  style={{color:"#28a745"}}></i>} {item.rank}</td>
                                               
                                              <td>{item.names}</td>
                                              <td>{item.total}</td>
                                            </tr>
                                          ))
                                        ) : (
                                          <tr>
                                            <td colSpan="3" style={{ textAlign: "center" }}>
                                              No voice calls rankings yet.
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                            )}
                          </div>
                          
                        </Tab.Pane>

                        <Tab.Pane eventKey="second">
                           <div className="table-responsive">
                            {loading6 ? (
                              <Loader /> 
                            ) : (
                              <table className="table table-hover text-nowrap mg-b-0">
                                      <thead>
                                        <tr>
                                        <th scope="col" >Pos</th>
                                        <th>Names</th>
                                        <th>Total</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {schoolRank?.video_calls?.length > 0 ? (
                                          schoolRank?.video_calls?.map((item, index) => (
                                            <tr key={index}>
                                               <td>{item.state === "same"? <i class="fas fa-minus"></i>:item.state ==="down"? <i class="fas fa-caret-down" style={{color:"#dc3545"}}></i>: <i class="fas fa-caret-up"  style={{color:"#28a745"}}></i>} {item.rank}</td>
                                               
                                              <td>{item.names}</td>
                                              <td>{item.total}</td>
                                            </tr>
                                          ))
                                        ) : (
                                          <tr>
                                            <td colSpan="3" style={{ textAlign: "center" }}>
                                              No video calls rankings yet.
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                            )}
                          </div>

                        </Tab.Pane>

                        <Tab.Pane eventKey="third">
                            <div className="table-responsive">
                            {loading6 ? (
                              <Loader /> 
                            ) : (
                              <table className="table table-hover text-nowrap mg-b-0">
                                      <thead>
                                        <tr>
                                        <th scope="col" >Pos</th>
                                        <th>Names</th>
                                        <th>Total</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {schoolRank?.direct_calls?.length > 0 ? (
                                          schoolRank?.direct_calls?.map((item, index) => (
                                            <tr key={index}>
                                               <td>{item.state === "same"? <i class="fas fa-minus"></i>:item.state ==="down"? <i class="fas fa-caret-down" style={{color:"#dc3545"}}></i>: <i class="fas fa-caret-up"  style={{color:"#28a745"}}></i>} {item.rank}</td>
                                               
                                              <td>{item.names}</td>
                                              <td>{item.total}</td>
                                            </tr>
                                          ))
                                        ) : (
                                          <tr>
                                            <td colSpan="3" style={{ textAlign: "center" }}>
                                              No direct calls rankings yet.
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                            )}
                          </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="fourth">
                            <div className="table-responsive">
                            {loading6 ? (
                              <Loader /> 
                            ) : (
                              <table className="table table-hover text-nowrap mg-b-0">
                                      <thead>
                                        <tr>
                                        <th scope="col" >Pos</th>
                                        <th>Names</th>
                                        <th>Total</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {schoolRank?.buzz_chats?.length > 0 ? (
                                          schoolRank?.buzz_chats?.map((item, index) => (
                                            <tr key={index}>
                                               <td>{item.state === "same"? <i class="fas fa-minus"></i>:item.state ==="down"? <i class="fas fa-caret-down" style={{color:"#dc3545"}}></i>: <i class="fas fa-caret-up"  style={{color:"#28a745"}}></i>} {item.rank}</td>
                                               
                                              <td>{item.names}</td>
                                              <td>{item.total}</td>
                                            </tr>
                                          ))
                                        ) : (
                                          <tr>
                                            <td colSpan="3" style={{ textAlign: "center" }}>
                                              No buzz chats rankings yet.
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                            )}
                          </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="fifth">
                            <div className="table-responsive">
                            {loading6 ? (
                              <Loader /> 
                            ) : (
                              <table className="table table-hover text-nowrap mg-b-0">
                                      <thead>
                                        <tr>
                                        <th scope="col" >Pos</th>
                                        <th>Names</th>
                                        <th>Total</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {schoolRank?.voice_notes?.length > 0 ? (
                                          schoolRank?.voice_notes?.map((item, index) => (
                                            <tr key={index}>
                                               <td>{item.state === "same"? <i class="fas fa-minus"></i>:item.state ==="down"? <i class="fas fa-caret-down" style={{color:"#dc3545"}}></i>: <i class="fas fa-caret-up"  style={{color:"#28a745"}}></i>} {item.rank}</td>
                                               
                                              <td>{item.names}</td>
                                              <td>{item.total}</td>
                                            </tr>
                                          ))
                                        ) : (
                                          <tr>
                                            <td colSpan="3" style={{ textAlign: "center" }}>
                                              No voice notes rankings yet.
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                            )}
                          </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="sixth">
                            <div className="table-responsive">
                            {loading6 ? (
                              <Loader /> 
                            ) : (
                              <table className="table table-hover text-nowrap mg-b-0">
                                      <thead>
                                        <tr>
                                        <th scope="col" >Pos</th>
                                        <th>Names</th>
                                        <th>Total</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {schoolRank?.direct_messages?.length > 0 ? (
                                          schoolRank?.direct_messages?.map((item, index) => (
                                            <tr key={index}>
                                               <td>{item.state === "same"? <i class="fas fa-minus"></i>:item.state ==="down"? <i class="fas fa-caret-down" style={{color:"#dc3545"}}></i>: <i class="fas fa-caret-up"  style={{color:"#28a745"}}></i>} {item.rank}</td>
                                               
                                              <td>{item.names}</td>
                                              <td>{item.total}</td>
                                            </tr>
                                          ))
                                        ) : (
                                          <tr>
                                            <td colSpan="3" style={{ textAlign: "center" }}>
                                              No direct messages rankings yet.
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                            )}
                          </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="seventh">
                            <div className="table-responsive">
                            {loading6 ? (
                              <Loader /> 
                            ) : (
                              <table className="table table-hover text-nowrap mg-b-0">
                                      <thead>
                                        <tr>
                                        <th scope="col" >Pos</th>
                                        <th>Names</th>
                                        <th>Total</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {schoolRank?.booth_sessions?.length > 0 ? (
                                          schoolRank?.booth_sessions?.map((item, index) => (
                                            <tr key={index}>
                                               <td>{item.state === "same"? <i class="fas fa-minus"></i>:item.state ==="down"? <i class="fas fa-caret-down" style={{color:"#dc3545"}}></i>: <i class="fas fa-caret-up"  style={{color:"#28a745"}}></i>} {item.rank}</td>
                                               
                                              <td>{item.names}</td>
                                              <td>{item.total}</td>
                                            </tr>
                                          ))
                                        ) : (
                                          <tr>
                                            <td colSpan="3" style={{ textAlign: "center" }}>
                                              No booth session rankings yet.
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                            )}
                          </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="eighth">
                            <div className="table-responsive">
                            {loading6 ? (
                              <Loader /> 
                            ) : (
                              <table className="table table-hover text-nowrap mg-b-0">
                                      <thead>
                                        <tr>
                                        <th scope="col" >Pos</th>
                                        <th>Names</th>
                                        <th>Total</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {schoolRank?.canteen_purchases?.length > 0 ? (
                                          schoolRank?.canteen_purchases?.map((item, index) => (
                                            <tr key={index}>
                                               <td>{item.state === "same"? <i class="fas fa-minus"></i>:item.state ==="down"? <i class="fas fa-caret-down" style={{color:"#dc3545"}}></i>: <i class="fas fa-caret-up"  style={{color:"#28a745"}}></i>} {item.rank}</td>
                                               
                                              <td>{item.names}</td>
                                              <td>{item.total}</td>
                                            </tr>
                                          ))
                                        ) : (
                                          <tr>
                                            <td colSpan="3" style={{ textAlign: "center" }}>
                                              No canteen purchases rankings yet.
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                            )}
                          </div>
                        </Tab.Pane>
                       
                      </Tab.Content>
                    </Col>
                  </Row>
                            </Tab.Container> 
                          

                        </Tab.Pane>
                      </Tab.Content>
                    </Col>
                  </Row>
                </Tab.Container>  

                  </div>
                </div>

              </div>
          </div>
          </div>

      
    </div>
    
  </section>
          

      </AppContainer>
  )
}

export default SchoolProfilePage;
